<script>
/**
 * Centered title bar — e.g. "TAX INVOICE" with optional subtitle for the
 * GST 3-copy convention ("ORIGINAL FOR RECIPIENT"). The subtitle defaults
 * to `data-copy-label` on the parent `.print-page`, populated from the
 * `?labels=` query string in PrintLayout.
 */
export default {
  name: "PrintTitle",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: null },
    inheritCopyLabel: { type: Boolean, default: true },
  },
  data() {
    return { copyLabel: null };
  },
  mounted() {
    if (!this.inheritCopyLabel) return;
    // Walk up to find the closest `.print-page` and read `data-copy-label`.
    let el = this.$el?.parentElement;
    while (el && !el.classList.contains("print-page")) {
      el = el.parentElement;
    }
    this.copyLabel = el?.getAttribute("data-copy-label") || null;
  },
  computed: {
    effectiveSubtitle() {
      return this.subtitle || this.copyLabel || null;
    },
  },
};
</script>

<template>
  <div class="print-title">
    <div class="print-title-main">{{ title }}</div>
    <div v-if="effectiveSubtitle" class="print-title-sub">{{ effectiveSubtitle }}</div>
  </div>
</template>

<style scoped>
.print-title {
  text-align: center;
  margin: 1mm 0 3mm;
  border-top: 0.5pt solid var(--print-border-strong);
  border-bottom: 0.5pt solid var(--print-border-strong);
  padding: 1mm 0;
}

.print-title-main {
  font-size: var(--print-fs-title);
  font-weight: 700;
  color: var(--print-accent);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  line-height: 1.15;
}

.print-title-sub {
  font-size: var(--print-fs-xs);
  color: var(--print-muted);
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin-top: 0.5mm;
  font-weight: 500;
}
</style>
